'use es6';

import PropTypes from 'prop-types';
import { Fragment, PureComponent } from 'react';
import keyMirror from 'react-utils/keyMirror';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { OPEN_PROGRESSIVE_PROFILING_FIELDS_EVENT } from 'FormsUI/constants/Events';
import { getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';
import { CommentableArea } from 'collaboration-sidebar';
import { PROGRESSIVE_PROFILING_MODULE_ID_POSTFIX } from 'FormsUI/constants/Commenting';
import { ENABLE_SMART_FIELD, DISABLE_SMART_FIELD } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PROGRESSIVE_PROFILING_TYPE = keyMirror({
  NONE: null,
  REPLACE: null
});
const langKey = path => `editor.form.config.progressiveProfiling.${path}`;
export default class ProgressiveProfilingConfiguration extends PureComponent {
  constructor() {
    super();
    this.handleSmartFieldChange = this.handleSmartFieldChange.bind(this);
  }
  handleSmartFieldChange({
    target: {
      value
    }
  }) {
    const {
      formField,
      updateSmartField
    } = this.props;
    switch (value) {
      case PROGRESSIVE_PROFILING_TYPE.NONE:
        trackEditorInteraction(DISABLE_SMART_FIELD);
        updateSmartField(formField, false);
        break;
      case PROGRESSIVE_PROFILING_TYPE.REPLACE:
        trackEditorInteraction(ENABLE_SMART_FIELD);
        this.handleShowQueuedFields();
        updateSmartField(formField, true);
        break;
      default:
    }
  }
  handleShowQueuedFields() {
    const event = new CustomEvent(OPEN_PROGRESSIVE_PROFILING_FIELDS_EVENT, {
      detail: {
        verification: true
      }
    });
    window.dispatchEvent(event);
  }
  getSelectOptions() {
    return [{
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('leaveField')
      }),
      value: PROGRESSIVE_PROFILING_TYPE.NONE
    }, {
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('replaceField')
      }),
      value: PROGRESSIVE_PROFILING_TYPE.REPLACE,
      help: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('replaceFieldInfo')
      })
    }];
  }
  getSelectValue(formField) {
    const {
      isSmartField
    } = formField;
    if (isSmartField) {
      return PROGRESSIVE_PROFILING_TYPE.REPLACE;
    }
    return PROGRESSIVE_PROFILING_TYPE.NONE;
  }
  render() {
    const {
      formField,
      disableFields,
      disableSelect
    } = this.props;
    return /*#__PURE__*/_jsx(CommentableArea, {
      moduleId: `${getPropertyObjectTypeId(formField)}${PROGRESSIVE_PROFILING_MODULE_ID_POSTFIX}`,
      description: {
        translationKey: 'formsProgressiveProfiling'
      },
      children: /*#__PURE__*/_jsxs(AccordionItem, {
        "data-test-id": "progressive-profiling-configuration",
        id: "progressive-profiling-configuration",
        title: /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: langKey('label')
          }), disableFields && /*#__PURE__*/_jsx(LockBadge, {})]
        }),
        defaultOpen: true,
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('message')
          })
        }), /*#__PURE__*/_jsx(Tooltip, {
          disabled: !disableSelect,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('tooltipAutomation')
          }),
          children: /*#__PURE__*/_jsx(Select, {
            "data-test-id": "progressive-profiling-select",
            options: this.getSelectOptions(),
            value: this.getSelectValue(formField),
            onChange: this.handleSmartFieldChange,
            disabled: disableFields || disableSelect
          })
        })]
      })
    });
  }
}
ProgressiveProfilingConfiguration.propTypes = {
  formField: PropTypes.object.isRequired,
  updateSmartField: PropTypes.func.isRequired,
  disableFields: PropTypes.bool,
  disableSelect: PropTypes.bool
};